import {connect} from 'react-redux';
import TopBanner from './TopBanner.jsx';
import {handleLogoClick} from './actions';
import {ENVIRONMENT} from 'shared/variables';

const mapStateTopProps = state => ({
  ...state.shared.topBanner,
  profileIsConfirmed: state.shared.auth.profileIsConfirmed,
  environment: ENVIRONMENT,
  groupName: state.shared.auth.groupName,
  isAllowed: state.shared.auth.isAllowed
});

const mapDispatchToProps = dispatch => ({
  onLogoClick: () => dispatch(handleLogoClick())
});

export default connect(mapStateTopProps, mapDispatchToProps)(TopBanner);



// WEBPACK FOOTER //
// ./src/features/shared/topBanner/TopBannerContainer.jsx